const STORAGE_KEY = "materialsTable_columnVisibility";

// default column visibility
export const DEFAULT_COLUMN_VISIBILITY = {
  material: true,
  quantity: false,
  remaining_qty: false,
  cost: true,
  latest_pickup: false,
  status: true,
  date_posted: true,
  delivery_instructions: false,
};

export const loadColumnVisibility = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      const parsed = JSON.parse(saved);
      // validate that all required fields are present
      const hasAllFields = Object.keys(DEFAULT_COLUMN_VISIBILITY).every(
        (key) => key in parsed
      );
      if (hasAllFields) {
        return parsed;
      }
    }
  } catch (error) {
    console.error("Error loading column visibility settings:", error);
  }
  // return default if no saved settings or error
  return DEFAULT_COLUMN_VISIBILITY;
};

export const saveColumnVisibility = (visibility) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(visibility));
    return true;
  } catch (error) {
    console.error("Error saving column visibility settings:", error);
    return false;
  }
};

export const resetColumnVisibility = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
    return DEFAULT_COLUMN_VISIBILITY;
  } catch (error) {
    console.error("Error resetting column visibility settings:", error);
    return DEFAULT_COLUMN_VISIBILITY;
  }
};
